import * as React from 'react';
import { useAd } from '../hooks/ad';
import { Native } from './native';
import { Banner } from './banner';
import { Placeholder } from './placeholder';
import { Fallback } from './fallback';
import { isNative } from '../utils/ast';
import { isTakeoverV2 } from '../utils/takeover';
import { Takeover } from './takeover';
import {
    DeviceType,
    Vertical,
    Subvertical,
    PageType,
    Features,
} from '../../shared/types/ast';

type Props = {
    id: string;
    className?: string;
    grid?: boolean;
    vertical?: Vertical;
    subvertical?: Subvertical;
    deviceType: DeviceType;
    pageType?: PageType;
    features?: Features;
};

export function Switch(props: Props) {
    const {
        id,
        className,
        grid = false,
        vertical,
        subvertical,
        deviceType,
        pageType = 'result',
        features,
    } = props;
    const { adObj, status, targetId } = useAd(
        id,
        deviceType,
        pageType,
        vertical,
        subvertical,
    );

    if (adObj) {
        if (isNative(adObj)) {
            return (
                <Native
                    adObj={adObj}
                    id={targetId}
                    className={className}
                    grid={grid}
                    vertical={vertical}
                    subvertical={subvertical}
                    status={status}
                    pageType={pageType}
                    deviceType={deviceType}
                    features={features}
                />
            );
        } else if (isTakeoverV2(adObj, deviceType)) {
            return (
                <Takeover id={id} targetId={targetId} className={className} />
            );
        } else {
            return <Banner id={id} targetId={targetId} className={className} />;
        }
    }

    if (status === 'failed') {
        return null;
    }

    return (
        <Placeholder id={targetId} className={className}>
            <Fallback id={id} deviceType={deviceType} />
        </Placeholder>
    );
}
